




















































































import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { namespace, State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { CoreStoreState } from '@/core';
import { UnifiedInsightsStoreState } from './unified-insights.store';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { localStorageKeeperService } from '@/shared/auth-service';
import { messageService } from '@libs-uuif/shared/message-service';
import { unifiedMessageContainer } from '@/shared/constants';
import _ from 'lodash';
import { componentMapping } from './widgets-configuration/widget-component-mapping';
import { nunitoSansFontContent } from './shared/nunito-sans';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { GridLayout, GridItem } from 'vue-grid-layout';
import SwWidget from '@/shared/widget-library/sw-widget.vue';
import DashboardHeader from './dashboard-header/dashboard-header.vue';
import InsertWidgetModal from './insert-new-widget-modal/insert-widget-modal.vue';
import { Widget } from '@/shared/types/widget-library.types';
import jsPDF from 'jspdf';
import { toPng } from 'html-to-image';
import moment from 'moment';
import Moment  from 'moment-timezone';

const cssPrefix = 'unified-insights';
const unifiedInsightsStoreModule = namespace('UnifiedInsightsStoreModule');

interface Orientation {
  type: 'p' | 'l' | 'portrait' | 'landscape';
}

@Component({
  components: {
    GridLayout,
    GridItem,
    SwWidget,
    SwButton,
    DashboardHeader,
    InsertWidgetModal,
  },
})

export default class UnifiedInsights extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @unifiedInsightsStoreModule.State
  widgets: UnifiedInsightsStoreState['widgets'];

  @unifiedInsightsStoreModule.State
  fixDashboardWidgetsLayout: UnifiedInsightsStoreState['fixDashboardWidgetsLayout'];

  @unifiedInsightsStoreModule.State
  disableSaveDashboardLayout: UnifiedInsightsStoreState['disableSaveDashboardLayout'];

  @unifiedInsightsStoreModule.State
  savedDashboardLayout: UnifiedInsightsStoreState['savedDashboardLayout'];

  @unifiedInsightsStoreModule.Mutation
  assignWidget: VuexMappedMutation<UnifiedInsightsStoreState['widgets']>;

  @unifiedInsightsStoreModule.Mutation
  setReadOnlyUser: VuexMappedMutation<UnifiedInsightsStoreState['isReadOnlyUser']>;

  @unifiedInsightsStoreModule.Mutation
  setFixDashboardWidgetsLayout: VuexMappedMutation<
    UnifiedInsightsStoreState['fixDashboardWidgetsLayout']
  >;

  @unifiedInsightsStoreModule.Mutation
  setDisableSaveDashboardLayout: VuexMappedMutation<
    UnifiedInsightsStoreState['disableSaveDashboardLayout']
  >;

  @unifiedInsightsStoreModule.Mutation
  setSavedDashboardLayout: VuexMappedMutation<
    UnifiedInsightsStoreState['savedDashboardLayout']
  >;

  @State((state: RootStoreState) => state.CoreStoreModule.tenantName)
  readonly tenantName: CoreStoreState['tenantName'];

  @State((state: RootStoreState) => state.UnifiedInsightsStoreModule.isReadOnlyUser)
  readonly isReadOnlyUser: UnifiedInsightsStoreState['isReadOnlyUser'];

  colNum: number = 12;
  isPageRefresh: boolean = false;
  rowHeight: number = 27;
  widgetsLayout: Widget[] = [];
  showReplaceWidgetModal: boolean = false;
  selectedWidgetIndex: number | null = null;
  windowResized: boolean = true;

  // Function to get mapped component from widget configurations
  getMappedComponent(component: string) {
    return componentMapping[component] || componentMapping['errorComponent'];
  }

  get readOnlyUser() {
    return this.isReadOnlyUser ? true : false;
  }

  @Watch('widgets', { deep: true, immediate: true })
  widgetsList() {
    if (this.fixDashboardWidgetsLayout) {
      this.getResizedLayout();
    } else if (this.widgets) {
      this.widgetsLayout = _.cloneDeep(this.widgets);
    } else {
      this.widgetsLayout = [];
    }
  }

  // This function will be called when the user clicks on the cancel or save button of insert widget modal
  onCloseModal() {
    this.showReplaceWidgetModal = false;
    this.selectedWidgetIndex = null;
  }

  // This function will be called when the user clicks on the cancel or save button of Edit/Replace Widget modal
  replaceWidget(index: number) {
    this.selectedWidgetIndex = index;
    this.showReplaceWidgetModal = true;
  }

  // This function will be called when the user clicks on the remove widget on the settings
  removeWidget(index: number) {
    const tempWidget = _.cloneDeep(this.widgets);
    tempWidget.splice(index, 1);
    const layout = _.orderBy(tempWidget, ['y', 'x'], ['asc']);
    !_.isEqual(this.savedDashboardLayout, layout) &&
        this.setDisableSaveDashboardLayout(false);
    this.assignWidget(this.fixWidgetsLayout(layout));
  }

  /**
   * @desc This function will be called on widget group by
   * @param {string} groupBy- selected groupBy
   * @param {number} index - index of grouped by widget
   */
  groupByWidget(groupByData: { groupBy: string; index: number }) {
    const tempWidget = _.cloneDeep(this.widgets);
    tempWidget[groupByData.index].groupBy = groupByData.groupBy;
    this.assignWidget(this.fixWidgetsLayout(tempWidget));
    localStorage.setItem('layout', JSON.stringify(tempWidget));
  }

  widgetAdded() {
    this.assignWidget(this.fixWidgetsLayout(this.widgetsLayout));
  }

/**
   * @desc This function is used for fixing the current widgets' layout,
   * so that empty space will be removed in the layout
   * @param {Widget} widgets- widgets
   */
  fixWidgetsLayout(widgets: Widget[]) {
    let x: number = 0;
    let y: number = 0;
    let prevY: number = 0;
    return [
      ...widgets.map((widget: any) => {
        const checkWidgetFit = x + widget.w;
        if (checkWidgetFit > this.colNum) {
          x = 0;
          y += prevY;
        }
        const newWidgetLayout = {
          ...widget,
          x,
          y,
          i: `${widget.title}`,
        };
        x += widget.w;
        prevY = widget.h;
        return newWidgetLayout;
      }),
    ];
  }

  // Function to resize the layout, based on current width
  private getResizedLayout() {
    this.windowResized = true;
    const width = window.innerWidth;
    if (width >= 1440) {
      this.colNum = 12;
    } else if (width >= 1030 && width < 1440) {
      this.colNum = 10;
    } else if (width < 1030) {
      this.colNum = 6;
    }
    const layout = this.fixWidgetsLayout(
      _.orderBy(
        this.fixDashboardWidgetsLayout ? this.widgets : this.widgetsLayout,
        ['y', 'x'],
        ['asc'],
      ),
    );
    if (this.fixDashboardWidgetsLayout) {
      this.setFixDashboardWidgetsLayout(false);
      this.setSavedDashboardLayout(layout);
      this.setDisableSaveDashboardLayout(true);
    }
    this.assignWidget(layout);
  }

  // This function will be called When the layout is updated.
  private layoutUpdatedEvent(newLayout: Widget[]) {
    if (_.isEqual(this.widgets, newLayout)) {
      this.windowResized = false;
      return;
    }
    const layout = _.orderBy(newLayout, ['y', 'x'], ['asc']);
    if (this.windowResized) {
      this.windowResized = false;
    } else {
      !_.isEqual(this.savedDashboardLayout, layout) &&
        this.setDisableSaveDashboardLayout(false);
    }
    this.assignWidget(layout);
  }

  // Generate PNG for widgets container and integrate with PDF.
  exportToPdf() {
    // 1 px = 0.2645833333 mm
    const unitParser: number = 0.2645833333;
    const divHeight = (this.$refs.data as HTMLElement).clientHeight * unitParser;
    const divWidth = (this.$refs.data as HTMLElement).clientWidth * unitParser;
    const reportHeight = divHeight + 20;
    const reportWidth =  divWidth + 20;
    const coverPageHeight = 290;
    const coverPageWidth = 310;
    messageService.messageManager
    .showMessage(
      unifiedMessageContainer,
      this.$t('spog.unifiedInsights.expRptMsg')
      .toString(),
      'informational',
    );
    toPng(this.$refs.data as HTMLElement, { backgroundColor: '#262626' })
    .then((dataUrl: any) => {
      const localStorageObject = localStorageKeeperService.retrieveJSON('currentUser');
      const accountName = localStorageObject['displayName'];
      const fileName = 'Unified_Insights_Dashboard';
      const orientation: Orientation = {
        type: 'p',
      };
      // If width is greater then height then show landscape mode else portrait mode
      if (reportWidth > reportHeight) orientation.type = 'l';
      // Front Page
      const pdf = new jsPDF('l', 'mm', [coverPageWidth, coverPageHeight]);
      pdf.addFileToVFS('NunitoSans-Regular-normal.ttf', nunitoSansFontContent);
      pdf.addFont('NunitoSans-Regular-normal.ttf', 'NunitoSans-Regular', 'normal');
      pdf.setFont('NunitoSans-Regular', 'normal');
      pdf.addImage(this.$refs.coverBg as HTMLImageElement, 'PNG', 0, 0, coverPageWidth, coverPageHeight);
      pdf.addImage(this.$refs.coverIcon as HTMLImageElement, 'PNG', 15, 10, 30, 50);
      pdf.addImage(this.$refs.coverLogo as HTMLImageElement, 'PNG', coverPageWidth - 70, 15, 50, 8);
      pdf.addImage(this.$refs.coverSlogan as HTMLImageElement, 'PNG', coverPageWidth - 70, coverPageHeight - 50, 50, 14);
      // Title Fonts Size - 32px
      pdf.setFontSize(32);
      pdf.setTextColor(255, 255, 255);
      pdf.text('Unified Insights', 15, 90);
      pdf.text('Dashboard Snapshot', 15, 110);
      // Content Fonts Size - 16px
      pdf.setFontSize(16);
      pdf.text(`${this.tenantName}`, 15, coverPageHeight - 140);
      const timeZoneAbbr = Moment.tz(Moment.tz.guess())
      .zoneName();
      const timeStamp: string = moment()
      .format('HHmm_DDMMYYYY');
      const timeFormat = moment()
      .format('LLL');
      pdf.text(`${timeFormat} ${timeZoneAbbr}`, 15, coverPageHeight - 128);
      pdf.text('Prepared By:', 15, coverPageHeight - 50);
      pdf.text(accountName, 15, coverPageHeight - 38);
      // Report Page
      pdf.addPage([reportWidth, reportHeight], orientation.type);
      pdf.addImage(dataUrl, 'PNG', 10, 10, divWidth, divHeight);
      pdf.save(`${fileName}_${this.tenantName}_${timeStamp}.pdf`);
      messageService.messageManager
      .showMessage(
        unifiedMessageContainer,
        this.$t('spog.unifiedInsights.expRptMsgSucc')
        .toString(),
        'success',
      );
    })
    .catch(() => {
      messageService.messageManager
      .showMessage(
        unifiedMessageContainer,
        this.$t('spog.unifiedInsights.expRptMsgFail')
        .toString(),
        'failed',
      );
    });
  }

  // When the page is created, saved layout is fetched.
  private async created() {
    this.checkIfReadOnlyUser();
    window.addEventListener('resize', this.getResizedLayout);
  }

  // before the page gets destroyed, eventListener for resize will be removed.
  private beforeDestroy() {
    window.removeEventListener('resize', this.getResizedLayout);
  }
  gridTitle(title: string) {
    return title.replace(/\s/g, '');
  }
  restoreDashboard() {
    this.assignWidget(this.savedDashboardLayout);
  }

  checkIfReadOnlyUser() {
    const currentUser = JSON.parse(
      localStorageKeeperService.retrieve('currentUser'),
    );
    let isReadOnly: boolean = false;
    if (currentUser &&
      currentUser.roles) {
      if (Array.isArray(currentUser.roles)) {
        isReadOnly = currentUser.roles.length > 0 &&
          currentUser.roles.includes('SPOGREADONLY') || false;
      } else if (typeof currentUser.roles === 'string') {
        isReadOnly = currentUser.roles &&
          currentUser.roles.indexOf('SPOGREADONLY') > -1 || false;
      } else {
        isReadOnly = false;
      }
    }
    this.setReadOnlyUser(isReadOnly);
  }
}
